// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57f68b2b","455":"f1b08ccf","977":"87991565"}[chunkId] + ".chunk.js";
};